import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { CUSTOMER_SOURCE_LABELS } from "@/features/customer/constants";
import type { CustomerSource } from "@/types/customer";

// Soft-tone colour-coding per channel, aligned with Estate design — low
// saturation surfaces with dark ink text, matching the lead status badges.
const SOURCE_COLORS: Record<CustomerSource, string> = {
  WALK_IN: "border-transparent bg-slate-100 text-slate-700",
  FACEBOOK: "border-transparent bg-blue-100 text-blue-700",
  ZALO: "border-transparent bg-sky-100 text-sky-700",
  REFERRAL: "border-transparent bg-emerald-100 text-emerald-700",
  OTHER: "border-transparent bg-zinc-100 text-zinc-600",
};

interface CustomerSourceBadgeProps {
  source: CustomerSource;
  className?: string;
}

export function CustomerSourceBadge({ source, className }: CustomerSourceBadgeProps) {
  return (
    <Badge className={cn(SOURCE_COLORS[source], className)}>
      {CUSTOMER_SOURCE_LABELS[source]}
    </Badge>
  );
}
